var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavDrawer'),_vm._v(" "),_c('v-main',{staticClass:"ml-11",style:({background: this.$vuetify.theme.themes.light.background})},[_c('v-container',{attrs:{"fluid":""}},[_c('breadcrumbs',{staticClass:"px-7 pt-6 pb-0"}),_vm._v(" "),_c('router-view',{staticClass:"px-7"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }